import { Geo } from './Api';

interface Storage {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
}

const CreateInMemoryStore = (): Storage => {
  const store: { [key: string]: string } = {};
  const get = (key: string) => store[key];
  const set = (key: string, value: string) => (store[key] = value);

  return {
    getItem: get,
    setItem: set
  };
};

const localStorageAvailable = function(): boolean {
  try {
    if (!localStorage) {
      return false;
    }
    localStorage.setItem('flipdish-test-key', 'flipdish-test-value');
    return localStorage.getItem('flipdish-test-key') === 'flipdish-test-value';
  } catch (error) {
    console.warn('This browser does not support local storage.', error);
    return false;
  }
};

const currentStore: Storage = localStorageAvailable() ? localStorage : CreateInMemoryStore();

export class Store<T> {
  private readonly key: string;

  constructor(key: string) {
    this.key = key;
  }

  public Save(data: T) {
    console.log('saving', this.key, data);
    const json: string = JSON.stringify(data, null, 2);
    currentStore.setItem(this.key, json);
  }

  public Load(): T | null {
    try {
      const json = currentStore.getItem(this.key);
      if (!json) {
        return null;
      }
      const object = JSON.parse(json);
      console.log('Loaded', this.key, object);
      return object;
    } catch (syntaxError) {
      console.warn('Syntax error loading', this.key, syntaxError);
      return null;
    }
  }
}

export let LocationStore = new Store<Geo>('flipdish-location');

try {
  // Delete old basket key - 2016-11-07
  localStorage.removeItem('flipdish-basket-item-store');
} catch (e) {}
